<div class="st-topic-full-screen-content">
    <div class="st-topic-full-screen-header">
        <div class="st-topic-full-screen-header__top-row">
            <st-topic-type
                class="st-topic-full-screen-header__topic-type"
                showAdd
                showRemove
                [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicType]?.Required"
                [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                [maxValuesToShow]="10"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                [value]="data()?.PSTTopicType"
                (changed)="updateTopic($event, pstFieldNames.PSTTopicType)" />
            @if (!data().isNewRecord) {
                <span class="st-topic-full-screen-header__time-updated">{{ timeUpdatedLabel() }}</span>
                <span class="st-topic-full-screen-header__updated-by">{{ updatedBy() }}</span>
            }
        </div>
        <div class="st-topic-full-screen-header__text">
            <div class="st-topic-full-screen-header__container">
                <st-text-area-overlay
                    #title
                    required
                    minRows="1"
                    minHeight="1rem"
                    class="st-topic-full-screen-header__container__title"
                    panelClass="st-topic-full-screen-header__container__title"
                    maxLength="50"
                    disableNewLine
                    maxOverlayRows="1"
                    [textToHighlight]="textAreaOverlayHighlight()"
                    [value]="data()?.Title"
                    [disabled]="topicDisabled()"
                    [label]="languageSettings().PSTWebSlugPlaceholder"
                    [placeholder]="languageSettings().PSTWebSlugPlaceholder"
                    (changed)="updateTopic($event, pstFieldNames.Title)" />

                <button
                    mat-icon-button
                    class="st-topic-full-screen-header__container__mos-control-active-button"
                    [matTooltip]="mosControlActiveTooltip()"
                    [disabled]="cardDisabled()"
                    (click)="mosControlActive()">
                    <mat-icon fontSet="st-icons">{{ mosControlActiveIcon() }}</mat-icon>
                </button>
                @if (globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp && !topicDisabled()) {
                    <button
                        class="st-topic-full-screen-header__container__approve"
                        mat-icon-button
                        [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTApproved]"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                        [class.st-topic-full-screen-header__container__approve--active]="data()?.PSTApproved"
                        (click)="updateTopic(!data()?.PSTApproved, pstFieldNames.PSTApproved)">
                        <mat-icon>done</mat-icon>
                    </button>
                }

                @if (!data().isNewRecord) {
                    <st-external-actions-overlay
                        inFullScreen
                        [data]="data()"
                        [editable]="topicEditable()"
                        [objectOpen]="topicOpenEmitter"
                        [disabled]="topicDisabled()"
                        (onDelete)="closeModal()" />
                }
            </div>
        </div>
        @if (showMatDivider()) {
            <mat-divider />
        }
    </div>

    <div
        #scrollableDiv
        class="st-topic-full-screen-main-content"
        [dir]="isRTL()">
        <st-text-area-overlay
            class="st-topic-full-screen-main-content__description"
            panelClass="st-topic-full-screen-main-content__description"
            minRows="3"
            minHeight="1rem"
            [textToHighlight]="textAreaOverlayHighlight()"
            [value]="data()?.Description"
            [disabled]="topicDisabled()"
            [required]="enforceRequiredFieldsOnCreate() && globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.Required"
            [placeholder]="globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
            [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
            (changed)="updateTopic($event, pstFieldNames.Description)" />
        <div class="st-topic-full-screen-main-content__options">
            <!-- <div class="st-topic-full-screen-main-content__tags"> -->
            <st-tags-autocomplete
                maxItemsToShow="10"
                [value]="data()?.Tags"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTags]"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.DefaultCaption"
                (changed)="updateTopic($event, pstFieldNames.PSTTags)" />
            <!-- </div> -->
            <div
                class="st-topic-full-screen-main-content__options__container"
                [dir]="isRTL()">
                <st-status
                    class="st-topic-full-screen-main-content__options__container__status"
                    [fieldName]="pstFieldNames.PSTTopicStatus"
                    [value]="data()?.PSTTopicStatus"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                    [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)"
                    [data]="data()"
                    [itemType]="data()?.PSTTopicStatus?.id"
                    [statusFieldName]="pstFieldNames.PSTTopicStatus"
                    [addEmptyOption]="!globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                    (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)" />
                @if (globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === fieldDefValidations.TIME) {
                    <st-date-time-picker
                        class="st-topic-full-screen-main-content__options__container__date-picker"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                        [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                        (timezoneChange)="timezoneChanged(pstFieldNames.TargetPublicationDate, $event)"
                        (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
                } @else {
                    <st-date-picker
                        class="st-topic-full-screen-main-content__options__container__date-picker"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                        [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                        (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
                }
                <st-desk
                    [value]="data()?.PSTGroup"
                    [data]="data()"
                    [fieldName]="pstFieldNames?.PSTDesk"
                    [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                    [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.PSTDesk)" />
                <st-staff-id-list
                    [value]="data()?.PSTTopicOwner"
                    [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)" />
            </div>
        </div>

        <ng-template *ngrxLet="customCardItems$ as customCardItems">
            @if (customCardItems.length > 0) {
                <div class="st-topic-full-screen-accordion-pane-container-property-group">
                    @for (idx of [0, 1, 2, 3]; track idx) {
                        @if (customCardItems[idx]) {
                            <ng-container
                                [ngTemplateOutlet]="groupingTemplate"
                                [ngTemplateOutletContext]="{ item: customCardItems[idx], data: data, isCustom: true }" />
                        }
                    }
                </div>
            }
        </ng-template>

        <mat-accordion
            #accordion
            class="st-topic-full-screen-accordion"
            displayMode="flat"
            togglePosition="before"
            multi>
            @for (group of groups(); track group?.name) {
                @switch (group.dynamic) {
                    @case (false) {
                        @switch (group.name) {
                            @case (languageSettings().PSTWebAttachmentsPane) {
                                @if (showAttachments()) {
                                    <mat-expansion-panel
                                        #paneContainer
                                        class="st-topic-full-screen-accordion-pane-container"
                                        [title]="attachmentsFieldGroupLabel()"
                                        [expanded]="expandedState()?.[`${sidecar()}${attachmentsFieldGroupLabel()}`]"
                                        (opened)="panelStateChanged(true, attachmentsFieldGroupLabel())"
                                        (closed)="panelStateChanged(false, attachmentsFieldGroupLabel())">
                                        <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                            <mat-panel-title>
                                                @if (!environment.demoModeNotForProduction) {
                                                    <st-beta class="st-expansion-panel-panel-header__beta" />
                                                }
                                                {{ attachmentsFieldGroupLabel() }}
                                            </mat-panel-title>
                                            <button
                                                mat-icon-button
                                                class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                                st-click-stop-propagation
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                                (click)="expandCollapseAll(paneContainer)">
                                                <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                            </button>
                                        </mat-expansion-panel-header>
                                        <st-attachments-list
                                            securityPrivilegeObject="topic"
                                            [disabled]="topicDisabled()"
                                            [record]="data()"
                                            (linkedRecordOpen)="onLinkedRecordOpenHandler($event)" />
                                    </mat-expansion-panel>
                                }
                            }
                            @case (languageSettings().PSTWebCoverageAssignmentsPane) {
                                <mat-expansion-panel
                                    #paneContainer
                                    class="st-topic-full-screen-accordion-pane-container"
                                    [expanded]="expandedState()?.[`${sidecar()}${coverageAssignmentsFiedGroupLabel()}`]"
                                    [class.st-topic-full-screen-required]="enforceRequiredFieldsOnCreate() && !areAssignmentsPopulated()"
                                    (opened)="panelStateChanged(true, coverageAssignmentsFiedGroupLabel())"
                                    (closed)="panelStateChanged(false, coverageAssignmentsFiedGroupLabel())">
                                    <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                        <mat-panel-title>{{ coverageAssignmentsFiedGroupLabel() }}</mat-panel-title>
                                        <div class="st-topic-full-screen-accordion-pane-container-assignment-actions">
                                            <st-assignment-creation-menu
                                                [types]="assignmentTypes()"
                                                [disabled]="topicDisabled()"
                                                [dir]="isRTL()"
                                                (typesSelected)="onAssignmentTypesSelected($event)" />
                                            <st-filter-trigger
                                                [config]="assignmentsFilterConfig()"
                                                [state]="assignmentsFilterState()"
                                                (stateChange)="onAssignmentsFilterStateChange($event)"
                                                (save)="onAssignmentsFilterSave()"
                                                (revert)="onAssignmentsFilterRevert()"
                                                (clear)="onAssignmentsFilterClear()" />

                                            <st-item-layout-toggle
                                                [isCondensed]="isAssignmentsCondensedLayout()"
                                                (layoutChange)="setAssignmentsCondensedLayout($event)" />

                                            <button
                                                mat-icon-button
                                                class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                                st-click-stop-propagation
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                                (click)="expandCollapseAll(paneContainer)">
                                                <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                            </button>
                                        </div>
                                    </mat-expansion-panel-header>
                                    @if (paneContainer.expanded) {
                                        @if (isAssignmentsCondensedLayout() && filteredAssignments()?.length) {
                                            <st-condensed-list-header-labels
                                                [cardViewType]="assignmentsCardViewType()"
                                                [variant]="ObjectTypes.ASSIGNMENT"
                                                [showApprove]="showAssignmentsApprove()" />
                                        }
                                        @for (item of filteredAssignments(); track item?.Guid) {
                                            @if (isAssignmentsCondensedLayout()) {
                                                <st-assignment-condensed
                                                    class="st-topic-full-screen-accordion-pane-container-assignment-item"
                                                    [data]="item"
                                                    [isReadOnly]="topicDisabled()"
                                                    [cardViewType]="assignmentsCardViewType()"
                                                    (assignmentItemClicked)="onAssignmentOpenHandler(item)" />
                                            } @else {
                                                <st-assignment-item
                                                    class="st-topic-full-screen-accordion-pane-container-assignment-item"
                                                    inFullscreenMode
                                                    [data]="item"
                                                    [cardViewType]="assignmentsCardViewType()"
                                                    [attr.small]="assignmentsCardViewType() === CardViewType.SMALL"
                                                    [disabled]="topicDisabled()"
                                                    (assignmentDeleteEmitter)="onAssignmentDeleteHandler()"
                                                    (assignmentOpenEmitter)="onAssignmentOpenHandler(item)" />
                                            }
                                        }
                                    }
                                </mat-expansion-panel>
                            }
                            @case (languageSettings().PSTWebStoriesPane) {
                                <mat-expansion-panel
                                    #paneContainer
                                    class="st-topic-full-screen-accordion-pane-container"
                                    [expanded]="expandedState()?.[`${sidecar()}${storiesFiedGroupLabel()}`]"
                                    [class.st-topic-full-screen-required]="enforceRequiredFieldsOnCreate() && !areStoriesPopulated()"
                                    (opened)="panelStateChanged(true, storiesFiedGroupLabel())"
                                    (closed)="panelStateChanged(false, storiesFiedGroupLabel())">
                                    <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                        <mat-panel-title>{{ storiesFiedGroupLabel() }}</mat-panel-title>
                                        <div class="st-topic-full-screen-accordion-pane-container-story-actions">
                                            <st-story-template-menu
                                                [templates]="storyTemplates()"
                                                [disabled]="!topicEditable()"
                                                [cardDisabled]="cardDisabled()"
                                                [dir]="isRTL()"
                                                [filterConfig]="storyTemplateFilterConfig()"
                                                [filterState]="storyTemplateFilterState()"
                                                (templatesSelected)="onStoryTemplateMenuClosed($event)"
                                                (filterStateChange)="onStoryTemplateFilterStateChange($event)"
                                                (filterSave)="onStoryTemplateFilterSave()"
                                                (filterRevert)="onStoryTemplateFilterRevert()"
                                                (filterClear)="onStoryTemplateFilterClear()" />
                                            <st-filter-trigger
                                                [config]="storiesFilterConfig()"
                                                [state]="storiesFilterState()"
                                                (stateChange)="onStoriesFilterStateChange($event)"
                                                (save)="onStoriesFilterSave()"
                                                (revert)="onStoriesFilterRevert()"
                                                (clear)="onStoriesFilterClear()" />
                                            <st-item-layout-toggle
                                                [isCondensed]="isStoriesCondensedLayout()"
                                                (layoutChange)="setStoriesCondensedLayout($event)" />
                                            <button
                                                mat-icon-button
                                                class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                                st-click-stop-propagation
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                                (click)="expandCollapseAll(paneContainer)">
                                                <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                            </button>
                                        </div>
                                    </mat-expansion-panel-header>
                                    @if (paneContainer.expanded) {
                                        @if (isStoriesCondensedLayout() && filteredStories()?.length) {
                                            <st-condensed-list-header-labels
                                                [cardViewType]="storiesCardViewType()"
                                                [showApprove]="showStoriesApprove()" />
                                        }
                                        @for (item of filteredStories(); track item.Guid) {
                                            @if (isStoriesCondensedLayout()) {
                                                <st-story-item-condensed
                                                    class="st-topic-full-screen-accordion-pane-container-story-item"
                                                    [data]="item"
                                                    [topicRecord]="data()"
                                                    [cardViewType]="storiesCardViewType()"
                                                    [isReadOnly]="topicDisabled()"
                                                    (storyItemClicked)="onStoryOpenHandler(item)" />
                                            } @else {
                                                <st-story-item
                                                    class="st-topic-full-screen-accordion-pane-container-story-item"
                                                    [data]="item"
                                                    [topicRecord]="data()"
                                                    [draggable]="item.isDraggable"
                                                    [disabled]="topicDisabled()"
                                                    [cardViewType]="storiesCardViewType()"
                                                    [attr.small]="storiesCardViewType() === CardViewType.SMALL"
                                                    (dragstart)="onDragStart($event, item)"
                                                    (storyDeleteEmitter)="storyDeleteEmitter.emit($event)"
                                                    (itemClicked)="onStoryOpenHandler(item)" />
                                            }
                                        }
                                    }
                                </mat-expansion-panel>
                            }
                            @default {
                                @for (item of specialProps(); track item?.ID) {
                                    @if (item?.Validation?.toUpperCase() === fieldDefValidations.SPECIAL && group.name === item.DefaultCaption) {
                                        <mat-expansion-panel
                                            #paneContainer
                                            class="st-topic-full-screen-accordion-pane-container"
                                            [class.st-topic-full-screen-required]="enforceRequiredFieldsOnCreate() && !requiredFieldGroups()[group?.name]"
                                            [expanded]="expandedState()?.[`${sidecar()}${item?.DefaultCaption}`]"
                                            (opened)="panelStateChanged(true, item?.DefaultCaption)"
                                            (closed)="panelStateChanged(false, item?.DefaultCaption)">
                                            <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                                <mat-panel-title>{{ item.DefaultCaption }}</mat-panel-title>
                                                <button
                                                    mat-icon-button
                                                    class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                                    st-click-stop-propagation
                                                    [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                                    (click)="expandCollapseAll(paneContainer)">
                                                    <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                                </button>
                                            </mat-expansion-panel-header>
                                            <st-special
                                                [value]="data()?.[item.ID]"
                                                [disabled]="topicDisabled()"
                                                [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)"
                                                (changed)="updateTopic($event, item.ID)" />
                                        </mat-expansion-panel>
                                    }
                                    @if (item?.Validation?.toUpperCase() === fieldDefValidations.COST && group.name === item.DefaultCaption && costVisible()) {
                                        <mat-expansion-panel
                                            #paneContainer
                                            class="st-topic-full-screen-accordion-pane-container"
                                            [class.st-topic-full-screen-required]="enforceRequiredFieldsOnCreate() && !requiredFieldGroups()[group?.name]"
                                            [expanded]="expandedState()?.[`${sidecar()}${item?.DefaultCaption}`]"
                                            (opened)="panelStateChanged(true, item?.DefaultCaption)"
                                            (closed)="panelStateChanged(false, item?.DefaultCaption)">
                                            <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                                <mat-panel-title>{{ item.DefaultCaption }}</mat-panel-title>
                                                <div class="st-topic-full-screen-accordion-pane-container-totalCost">
                                                    <span title>{{ data()?.[item.ID]?.totalCost | currency: 'USD' }}</span>
                                                    <button
                                                        mat-icon-button
                                                        class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                                        st-click-stop-propagation
                                                        [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                                        (click)="expandCollapseAll(paneContainer)">
                                                        <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                                    </button>
                                                </div>
                                            </mat-expansion-panel-header>
                                            <st-special-cost
                                                [required]="enforceRequiredFieldsOnCreate() && item.Required"
                                                [value]="data()?.[item.ID]"
                                                [disabled]="costDisabled()"
                                                [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)"
                                                (changed)="updateTopic($event, item.ID)" />
                                        </mat-expansion-panel>
                                    }
                                }
                            }
                        }
                    }
                    @default {
                        @if (data()?.visibilityCriteriaGroups?.[group?.name]) {
                            <mat-expansion-panel
                                #paneContainer
                                class="st-topic-full-screen-accordion-pane-container"
                                [expanded]="expandedState()?.[`${sidecar()}${group.label}`]"
                                [class.st-topic-full-screen-required]="enforceRequiredFieldsOnCreate() && !requiredFieldGroups()?.[group?.name]"
                                (opened)="panelStateChanged(true, group.label)"
                                (closed)="panelStateChanged(false, group.label)">
                                <mat-expansion-panel-header class="st-expansion-panel-panel-header">
                                    <mat-panel-title>{{ group.label }}</mat-panel-title>
                                    <button
                                        mat-icon-button
                                        class="st-topic-full-screen-accordion-pane-container__expand-collapse"
                                        st-click-stop-propagation
                                        [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                                        (click)="expandCollapseAll(paneContainer)">
                                        <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                                    </button>
                                </mat-expansion-panel-header>
                                <div class="st-topic-full-screen-accordion-pane-container-property-group">
                                    <ng-container
                                        [ngTemplateOutlet]="groupingTemplate"
                                        [ngTemplateOutletContext]="{ data: data, isCustom: false, group: group }" />
                                </div>
                            </mat-expansion-panel>
                        }
                    }
                }
            }
        </mat-accordion>
    </div>
</div>
@if (isCreate()) {
    <div class="st-topic-full-screen-create-footer">
        <mat-divider />
        <div class="st-topic-full-screen-create-footer-buttons">
            <button
                mat-button
                matRipple
                [disabled]="disabled()"
                [matRippleRadius]="15"
                (click)="create(false)">
                @if (!loading()) {
                    {{ languageSettings().PSTWebSaveAndCloseButtonLabel }}
                } @else {
                    <ng-container [ngTemplateOutlet]="loader" />
                }
            </button>
            <button
                mat-button
                color="primary"
                [disabled]="disabled()"
                (click)="create(true)">
                @if (!loadingSaveAndNext()) {
                    {{ languageSettings().PSTWebSaveAndContinueButtonLabel }}
                } @else {
                    <ng-container [ngTemplateOutlet]="loader" />
                }
            </button>
        </div>
    </div>
}

<ng-template #loader>
    <st-loader
        class="st-topic-full-screen-create-footer-buttons--spinner"
        [diameter]="30"
        [strokeWidth]="5" />
</ng-template>
<ng-template
    #groupingTemplate
    let-group="group"
    let-item="item"
    let-validation="validation"
    let-isCustom="isCustom">
    @if (isCustom) {
        <ng-container
            [ngTemplateOutlet]="fieldsTemplate"
            [ngTemplateOutletContext]="{ data: data, isCustom: true, group: group, item: item }" />
    } @else {
        @for (item of group.items; track item?.ID) {
            <ng-container
                [ngTemplateOutlet]="fieldsTemplate"
                [ngTemplateOutletContext]="{ data: data, isCustom: false, group: group, j: $index, item: item }" />
        }
    }
    <ng-template
        #fieldsTemplate
        let-item="item"
        let-data="data"
        let-j="index"
        let-isCustom="isCustom">
        @if (data()?.visibilityCriteria?.[item?.ID] || isCustom) {
            <div class="st-topic-full-screen-accordion-pane-container-property-container">
                @if (item?.Validation?.toUpperCase() !== 'CHECKBOX') {
                    <span class="st-topic-full-screen-accordion-pane-container-property__label">
                        {{ item?.DefaultCaption }}
                    </span>
                }
                @switch (item?.Validation?.toUpperCase()) {
                    @case ('TEXT') {
                        @if (item.WordWrap === false) {
                            <st-text-field
                                showLinks
                                [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                                [required]="enforceRequiredFieldsOnCreate() && item.Required"
                                [textToHighlight]="searchString$ | ngrxPush"
                                [placeholder]="item.DefaultCaption"
                                [value]="data()?.[item.ID]"
                                (changed)="updateTopic($event, item.ID)" />
                        } @else {
                            <st-text-area
                                showLinks
                                [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                                [textToHighlight]="searchString$ | ngrxPush"
                                [required]="enforceRequiredFieldsOnCreate() && item.Required"
                                [placeholder]="item.DefaultCaption"
                                [value]="data()?.[item.ID]"
                                (changed)="updateTopic($event, item.ID)" />
                        }
                    }
                    @case ('COMBOBOX') {
                        <st-combo-box
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [placeholder]="item.DefaultCaption"
                            [addEmptyOption]="!item.Required"
                            [value]="data()?.[item.ID]"
                            [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('CHECKLIST') {
                        <st-check-list
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [value]="data()?.[item.ID]"
                            [data]="data()"
                            [fieldName]="item.ID"
                            [placeholder]="item.DefaultCaption"
                            [itemList]="globalTablesService.getListItems(item.ID, item.List)"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('CHECKBOX') {
                        <st-check-box
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('DATE') {
                        <st-date-picker
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('TIME') {
                        <st-date-time-picker
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (timezoneChange)="timezoneChanged(item.ID, $event)"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('MOSDATETIME') {
                        <st-date-time-picker
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (timezoneChange)="timezoneChanged(item.ID, $event)"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('DATETIMERANGE') {
                        <st-date-time-range
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('STAFFIDLIST') {
                        <st-staff-id-list-multiple
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('TREE') {
                        <st-tree
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [value]="data()?.[item.ID]"
                            [placeholder]="item.DefaultCaption"
                            [itemList]="globalTablesService.getlistItemsForTree(item.List)"
                            [addEmptyOption]="!item.Required"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('DURATION') {
                        <st-duration-seconds-input-field
                            [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                            [required]="enforceRequiredFieldsOnCreate() && item.Required"
                            [tabindex]="j"
                            [placeholder]="item.DefaultCaption"
                            [value]="data()?.[item.ID]"
                            (changed)="updateTopic($event, item.ID)" />
                    }
                    @case ('ADDRESS') {
                        @if (item.ComplexPropInnerId) {
                            <st-text-field
                                floating
                                [placeholder]="item.DefaultCaption"
                                [required]="enforceRequiredFieldsOnCreate() && item.Required"
                                [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                                [textToHighlight]="searchString$ | ngrxPush"
                                [value]="getInnerProp(item)"
                                (changed)="updateTopicAddresSubField($event, item, item.ComplexPropInnerId)" />
                        } @else {
                            <st-address-form
                                [required]="enforceRequiredFieldsOnCreate() && item.Required"
                                [disabled]="item.ReadOnlyValue || topicDisabled() || data()?.readOnlyCriteria[item?.ID]"
                                [placeholder]="item.DefaultCaption"
                                [value]="data()?.[item.ID]"
                                (changed)="updateTopic($event, item.ID)" />
                        }
                    }
                }
            </div>
        }
    </ng-template>
</ng-template>
